import AppDispatcher from '../../../../flux/dispatcher/dispatcher';
import Constant from '../constant/Constant';
import restClient from '../../../../routers/MainFrame/action/APIClient';
import LogoutConstant from '../../../../routers/MainFrame/constants/Constants';
import urlConfig from '../../../../config/index';
var moment = require('moment');
var organization, country, locality, area, profileId, granularity = 'weekly';
var dateRange = {}, filters = {};

var InsightGroupBarchartAction = function () {

}

InsightGroupBarchartAction.prototype = {

	clearFilters: function () {
		filters = {};
		organization = "";
		country = undefined;
		locality = undefined;
		area = undefined;
		granularity = 'weekly';
	},

	addDownloadFilters: function (data) {
		if (data.profileId) {
			profileId = data.profileId;
			delete data.profileId
		}
		if (data.granularity) {
			granularity = data.granularity;
			// delete data.granularity;
		}
		filters = data;
		this.loadData();
		this.loadDataCustomer();
	},

	addFilters: function (data, newGranularity) {
		filters = data;
		granularity = newGranularity;
		this.loadData();
		this.loadDataCustomer();
	},

	changeProfile: function (value) {
		profileId = value;
		this.loadData();
		this.loadDataCustomer();
	},

	// clearFilters: function () {
	// 	organization = "";
	// 	country = undefined;
	// 	locality = undefined;
	// 	area = undefined;
	// 	granularity = 'weekly';
	// },

	changeOrganisation: function (value) {
		organization = value;
		this.loadData();
		this.loadDataCustomer();
	},

	addCountry: function (value) {
		country = value;
		locality = undefined;
		area = undefined;
		this.loadData()
		this.loadDataCustomer();
	},

	addArea: function (value) {
		area = value;
		locality = undefined;
		this.loadData();
		this.loadDataCustomer();
	},

	addLocality: function (value) {
		locality = value;
		this.loadData();
		this.loadDataCustomer();
	},

	addDates: function (fromDate, toDate) {
		dateRange.from = fromDate;
		dateRange.to = toDate;
		this.loadData();
		this.loadDataCustomer();
	},

	changeGranularity: function (value) {
		granularity = value;
		this.loadData();
		this.loadDataCustomer();
	},

	loadData: function () {
		if (!(filters.hasOwnProperty('dateRange'))) {
			dateRange.from = moment().subtract(16, 'week').format('YYYY-MM-DD');
			dateRange.to = moment().format('YYYY-MM-DD');
			filters['dateRange'] = dateRange;
		}

		let modifiedFilters = JSON.parse(JSON.stringify(filters));
		modifiedFilters['insightFilters'] = {
			"metrics": [
				"PHOTOS_VIEWS_MERCHANT",
				"PHOTOS_COUNT_MERCHANT"
			]
		}

		var data = {
			profileId: localStorage.getItem('profileId'),
			granularity: granularity,
			filters: modifiedFilters
		};


		restClient.getLocationInsightHistogram(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.INSIGHTS_BAR,
					data: response
				});
			}

		})
	},
	loadDataCustomer: function () {
		if (!(filters.hasOwnProperty('dateRange'))) {
			dateRange.from = moment().subtract(16, 'week').format('YYYY-MM-DD');
			dateRange.to = moment().format('YYYY-MM-DD');
			filters['dateRange'] = dateRange;
		}

		filters['insightFilters'] = {
			"metrics": [
				"PHOTOS_VIEWS_CUSTOMERS",
				"PHOTOS_COUNT_CUSTOMERS"
			]
		}
		var data = {
			profileId: localStorage.getItem('profileId'),
			granularity: granularity,
			filters: filters
		};


		restClient.getLocationInsightHistogram(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.INSIGHTS_BAR_CUSTOMER,
					data: response
				});
			}

		})
	},
	downloadReviewLocation() {
		var urlName = urlConfig.urlName;
		var data = {
			profileId: localStorage.getItem('profileId'),
			granularity: granularity,
			domainName: urlName,
			filters: filters
		};
		filters['insightFilters'] = {
			"metrics": [
				"PHOTOS_VIEWS_MERCHANT",
				"PHOTOS_COUNT_MERCHANT"
			]
		}
		restClient.getLocationInsightHistogramCsv(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {

				AppDispatcher.dispatch({
					actionType: Constant.PHOTO_VIEWS_CSV,
					data: response
				});
			}

		})
	},
	downloadCustomerReviewLocation() {
		var urlName = urlConfig.urlName;
		var data = {
			profileId: localStorage.getItem('profileId'),
			granularity: granularity,
			domainName: urlName,
			filters: filters
		};
		filters['insightFilters'] = {
			"metrics": [
				"PHOTOS_VIEWS_CUSTOMERS",
				"PHOTOS_COUNT_CUSTOMERS"
			]
		}
		restClient.getLocationInsightHistogramCsv(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.PHOTO_VIEWS_CUSTOMER_CSV,
					data: response
				});
			}
		})
	}
}

export default new InsightGroupBarchartAction();
